document.addEventListener('DOMContentLoaded', function () {
  class V5ScrollVideoKv2 {
    constructor() {
      this.sectionId = '#v5ScrollVideoKv2';
      this.v5ScrollVideoKv2Trigger = null;
      this.section = document.querySelector(this.sectionId);
      this.subtitle1H = this.section.querySelector('.subtitle1').offsetHeight;
      this.title1H = this.section.querySelector('.title1').offsetHeight;
      this.contentBox2H = this.section.querySelector('.content-box-2').offsetHeight;
      this.video =
        window.innerWidth > 1023
          ? this.section.querySelector('.pc-video-wrap viewport-video')
          : this.section.querySelector('.mb-video-wrap viewport-video');
      this.init();

      // 动态生成 anchor
      const shopifySection = this.section.closest('.shopify-section');
      const anchorV5 = this.section.getAttribute('data-anchor-v5');
      if (shopifySection && anchorV5) {
        shopifySection.setAttribute('data-anchor-v5', anchorV5);
      }
    }
    init() {
      this.scrollTimeLine();
      this.scrollListener();
      this.observeFunc();
    }
    scrollListener() {
      // 添加状态记录变量
      let lastViewportState = null; // null: 初始状态, true: 在视口内, false: 在视口外
      const throttledScroll = window.throttle(() => {
        const isIn = window.Jackery.Utils.isElementInViewport(this.section);
        const currentState = isIn; // true: 在视口内, false: 在视口外

        // 只有状态发生变化时才执行
        if (lastViewportState === currentState) return;
        lastViewportState = currentState;
        const videoPlay = this.section.getAttribute('data-video-play');
        if (this.video && videoPlay == 'true') {
          if (isIn) {
            // 进入视窗，开始播放
            this.video.play();
          } else {
            // 不在视窗停止播放
            this.video.pause();
          }
        }
      }, 150);
      window.addEventListener('scroll', throttledScroll, { passive: true });
    }

    observeFunc(){
      const self = this;
      // 橱窗版块的DOM元素 需要持续监听
      const pdpInfoContainer = document.querySelector('.section-v5-main-product') || document.querySelector('.product-info-container');

      // 该组件需要持续监听
      const v5Accordion = document.querySelector('.section-v5-accordion');
      if (pdpInfoContainer || v5Accordion) {
        // 创建防抖函数来限制refresh频率
        const debouncedRefresh = window.throttle(() => {
          if (self.v5ScrollVideoKv2Trigger && typeof self.v5ScrollVideoKv2Trigger.refresh === 'function') {
            self.v5ScrollVideoKv2Trigger.refresh();
          }
          // 观察到变更后，启动/重置空闲期清理计时器
          // if(pdpInfoContainer){
          //   scheduleIdleCleanup();
          // }
        }, 100); // 100ms内最多执行一次

        // 创建ResizeObserver实例
        const observer = new ResizeObserver((entries) => {
          // 检查是否有实际的尺寸变化
          for (let entry of entries) {
            const { height } = entry.contentRect;
            // 只有当尺寸发生实际变化时才触发刷新
            if (height > 0) {
              debouncedRefresh();
              break;
            }
          }
        });

        // 在一段"空闲期"后自动清理，避免过早地 load 时断开监听
        let resizeIdleTimer = null;
        const scheduleIdleCleanup = () => {
          if (resizeIdleTimer) clearTimeout(resizeIdleTimer);
          resizeIdleTimer = setTimeout(() => {
            // 橱窗稳定，卸载监听
            cleanupObserver();
          }, 120000); // 2min，根据需要调整空闲期时长
        };

        // 开始观察元素尺寸变化
        [pdpInfoContainer, v5Accordion].forEach(element => {
          if (element) {
            observer.observe(element);
          }
        });

        // 断开观察
        const cleanupObserver = () => {
          if (observer) {
            observer.disconnect();
          }
          if (resizeIdleTimer) {
            clearTimeout(resizeIdleTimer);
            resizeIdleTimer = null;
          }
        };

        // 在页面隐藏或离开时清理，避免遗漏 load 之后生成的 DOM
        window.addEventListener('pagehide', cleanupObserver);
        document.addEventListener('visibilitychange', function () {
          if (document.visibilityState === 'hidden') cleanupObserver();
        });

        // 清理保障：当组件卸载时也应该断开观察
        if (window.Shopify && window.Shopify.designMode && this.section) {
          const parentSection = this.section.closest('.shopify-section');
          if (parentSection) {
            parentSection.addEventListener('section:unload', cleanupObserver);
          }
        }
      }
    }

    // 滚动动画
    scrollTimeLine() {
      if (!window._scrollTriggerRegistered) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        window._scrollTriggerRegistered = true;
      }

      const self = this;
      let topH = '4.1666667vw';
      const productTabsBox = document.querySelector('.product-tabs-box,.section-navigation');
      if (productTabsBox) {
        topH = productTabsBox.offsetHeight + 'px';
      } else {
        const header = document.querySelector('jky-header,header-v5');
        topH = header.offsetHeight + 'px';
      }

      let tl;
      // 储存实例动画已经进行了多长的时间
      const time = tl ? tl.time() : 0;
      if (tl) {
        tl.kill();
      }
      tl = window.gsap.timeline({ paused: true });
      self.v5ScrollVideoKv2Trigger = window.ScrollTrigger.create({
        trigger: self.sectionId,
        pin: true, // 将触发元素固定，在激活时
        start: `top ${topH}`, // 当触发元素的顶部碰到视口顶部时
        end: `bottom 70%`, // 在起始位置滚动 xxx 后结束
        scrub: 1, // 平滑擦洗，需要2秒钟来“赶上”滚动条
        smoothChildTiming: true,
        // markers: true,
        snap: [0, 1],
        animation: tl,
      })

      // 文字动效
      tl.addLabel('start')
        // 第一段事件：副标题1 + 标题1位移，结束开始播放视频
        .to('.v5-scroll-video-kv-2 .subtitle1', {
          y: `-${this.subtitle1H + 164}px`,
          ease: 'none',
          opacity: 0,
          duration: 0.2,
        })
        .to(
          '.v5-scroll-video-kv-2 .title1',
          {
            y: `-${this.subtitle1H}px`,
            fontSize: window.innerWidth < 1024 ? '0.875rem' : '2rem',
            lineHeight: window.innerWidth < 1024 ? '1.05rem' : '3.625rem',
            ease: 'none',
            opacity: 0,
            duration: 0.5,
            onUpdate: () => {
              const videoPlay = this.section.getAttribute('data-video-play');
              if (videoPlay === 'true' && this.video) {
                this.video.pause();
                this.section.setAttribute('data-video-play', 'false');
              }
            },
            onComplete: () => {
              if (this.video) {
                this.video.play();
                this.section.setAttribute('data-video-play', 'true');
              }
            },
          },
          '<'
        )
        // 第二段事件：副标题2、标题2位移
        .to(
          '.v5-scroll-video-kv-2 .subtitle2',
          {
            y: `-300px`,
            ease: 'none',
            opacity: 1,
            duration: 0.5,
          },
          '<'
        )
        .to(
          '.v5-scroll-video-kv-2 .title2',
          {
            y: `-500px`,
            ease: 'none',
            opacity: 1,
            duration: 0.5,
          },
          '<'
        )
        .addLabel('end');

      tl.time(time);
    }
  }
  new V5ScrollVideoKv2();
});